import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { ThisPlatform } from "src/app/_services/platform.service";
import { AuthenticationService } from "src/app/_services/authentication.service";

@Component({
  selector: "app-disabled",
  templateUrl: "./disabled.page.html",
  styleUrls: ["./disabled.page.scss"],
})
export class DisabledPage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private location: Location,
    public p: ThisPlatform,
    private authenticationServ: AuthenticationService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((paramMap) => {
      if (!paramMap.has("module")) {
        this.location.back();
        return;
      }

      this.checkAvailability(paramMap.get("module"))
    });
  }

  checkAvailability(module) {
    this.authenticationServ.userModules.forEach( el => {
      const checkModule = el.url.split('/').pop();
      if(checkModule == module) {
        this.router.navigate(["/app/"+ module]);
      }

    })
  }
}
